<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Content from '@/services/Content'
import Swal from "sweetalert2";
import modalUpdatePinFeed from '@/components/modals/news/modalUpdatePinFeed';
import modalEditVerticalImage from '@/components/modals/news/modalEditVerticalImage';
import General from "@/services/General";



export default {
  components: { Layout, PageHeader, modalUpdatePinFeed, modalEditVerticalImage},
  page: {
    title: "Business News",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  watch: {
    selectedLang(newLang) {
      this.getNewsFeed(newLang); // Call API with the selected language
    }
  },
  data() {
    return {
      title: "Feed",
      items: [
        {
          text: "News",
        },
        {
          text: "Feed",
          active: true,
          href: "/news/sport_news_feed",
        },
      ],
      showRefresh:true,
      showAlert: false,
      isBusyButton: false,
      isBusy: false,
      tryingToSubmit:false,
      showLoader:false,
      id: this.$route.params.id,
      tableData: [],
      pinDate: "",
      verticalImage: "",
      currentPage: 1,
      perPage: 1,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      selectedLang:'',
      newsLanguage: [],
      content_types:[],
      isFeedEnabled:null
    };
  },

  computed: {

    totalRows() {
      return this.tableData.length;
    },
    currentImage() {
      return this.tableData[this.currentPage - 1] || null;
    },
    isPinned() {
      if (!this.currentImage || !this.currentImage.pin_end_time) {
        return false;
      }
      return new Date(this.currentImage.pin_end_time) >= new Date();
    },
    isFeedEmpty() {
      return this.tableData.length === 0;
    }
  },

  methods: {
    async loadAppParams() {
      this.isLoadingParams = true;
      try {
        const response = await General.getAppParams();
        if (response && response.data && response.data.app_params && Array.isArray(response.data.app_params)) {
          const params = response.data.app_params;
          const feeEnabled = params.find(p => p.key === 'feedEnabled');
          console.log(params,'params');
          console.log(response,'res');
          console.log(feeEnabled,'feeEnabled');

          if(feeEnabled){
            this.isFeedEnabled = feeEnabled.value === 1;
          }else{
            this.isFeedEnabled = false;
          }
          console.log(this.isFeedEnabled,'this.isFeedEnabled');

        }
      } catch (error) {
        console.error('Failed to load app params:', error);
      } finally {
        this.isLoadingParams = false;
      }
    },
    async getNewsFeed(language, focusItemId) {
      this.showLoader =  true

      try {
        this.toggleBusy();
        const response = await Content.getNewsFeed(language);
        console.log(response,'response');

        if (response.data.feed && response.data.feed.length > 0) {
          this.tableData = response.data.feed;
          if (response.data.pinned && response.data.pinned.length > 0) {
            const pinnedIds = response.data.pinned.map(p => p.id);
            const feedWithoutPinned = this.tableData.filter(item => !pinnedIds.includes(item.id));
            this.tableData = [...response.data.pinned, ...feedWithoutPinned];
          }
        } else {
          this.tableData = response.data.pinned && response.data.pinned.length > 0 ? [...response.data.pinned] : [];
        }

        if (focusItemId) {
          const idx = this.tableData.findIndex(item => item.id === focusItemId);
          if (idx !== -1) {
            this.currentPage = idx + 1;
          }
        }

        this.toggleBusy();
      } catch (error) {
        console.error("Error fetching news feed:", error);
        this.tableData = [];
      }finally {
        this.showLoader =  false
      }
    },
    async getNewsLanguage(){
      try {
        this.toggleBusy();
        const response = await Content.getNewsLanguage()
        this.newsLanguage = response.data
        this.toggleBusy();
      } catch (error) {
        this.toggleBusy();
        this.error = error.response.data.error ? error.response.data.error : "";
        this.tableData = []
        this.totalRows = 0;
      }
    },

    async handlePinAction() {
      if (this.tryingToSubmit || this.showLoader) return;

      if (this.isPinned) {
        const today = new Date();
        const formattedDate = today.toISOString().split("T")[0];

        await this.submitForm(formattedDate);
      } else {
        this.callModalUpdatePinFeed(this.currentImage);
      }
    },

    async getTenantContentTypes(){
      try {
        this.toggleBusy();
        const response = await Content.getTenantContentTypes();
        console.log(response,'response content types');
        this.content_types = response.data.data
        this.toggleBusy();
      } catch (error) {
        this.toggleBusy();
        this.error = error.response.data.error ? error.response.data.error : "";
        this.tableData = []
        this.totalRows = 0;
      }
    },

    async submitForm(pinEndTime) {
      this.tryingToSubmit = true;
      this.submitted = true;



      try {
        let formData = new FormData();
        formData.append('pin_end_time', pinEndTime);
        formData.append('type', this.currentImage.type);
        formData.append('content_type', this.currentImage.content_type);
        formData.append('csrf_token', this.csrf_token);
        formData.append('_method', 'PATCH');
        const response = await Content.updateFeed(this.currentImage.id, formData);
        if (response.success === false) {
          Swal.fire("Error", response.error || "Failed to Unpin Feed. Please try again.", "error");
        } else {
          Swal.fire("Success", "Unpin successfully!", "success");
          this.getNewsFeed(this.selectedLang, this.currentImage.id);
        }

      } catch (error) {
        console.error("Failed to create brand:", error);
        Swal.fire("Error", error.response?.data?.error || "Failed to Unpin Feed. Please try again.", "error");
      } finally {
        this.tryingToSubmit = false;
        this.showLoader = false;
      }
    },
    handleClick() {
      if (!this.currentImage) return;
      
      if (this.currentImage.content_type === "video" || this.currentImage.content_type === "short") {
        if (this.currentImage.videourl) {
          window.open(this.currentImage.videourl, "_blank");
        }
      } else if (this.currentImage.link) {
        window.open(this.currentImage.link, "_blank");
      }
    },

 async handleStatusChange(item) {
       this.showLoader =  true;
       try {
         const dataToUpdate = {
           content_type: item.content_type,
           status: item.status,
         };
         const response = await Content.updateTenantContentType(dataToUpdate);
         if (response.data) {
            this.getNewsFeed(this.selectedLang);
         } else {
           const error = response.data.error ? response.data.error : 'Failed';
           this.failedmsg(error);
         }
       } catch (error) {
         this.failedmsg(error.message);
       } finally {
         this.showLoader = false;
       }
     },
    decodeHtmlEntities(str) {
      if (!str) return '';
      let doc = new DOMParser().parseFromString(str, "text/html");
      return doc.documentElement.textContent;
    },
    callModalUpdatePinFeed(currentImage) {
      this.pinDate = currentImage;
      this.$bvModal.show("update_pin");
    },
    callModalEditVerticalImage(currentImage) {
      this.verticalImage = currentImage;
      this.$bvModal.show("update_vertical_image");
    }


  },
  created() {
    this.loadAppParams();
    this.getNewsFeed();
    this.getNewsLanguage();
    this.getTenantContentTypes();
  },
  middleware: "authentication",
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div v-if="!isFeedEnabled && isFeedEnabled !== null">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body text-center py-5">
              <i class="mdi mdi-newspaper-variant-outline fs-1 text-muted mb-3"></i>
              <h4 class="text-muted">Feed is not enabled</h4>
              <p class="text-muted">Please contact Azerion for more information.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <template v-if="content_types && content_types.length > 0">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex flex-nowrap align-items-center justify-content-start gap-3 gap-md-4 overflow-auto">
                <p class="fw-bold mb-0 text-nowrap flex-shrink-0">Content types included on feed:</p>

                <div
                  v-for="item in content_types"
                  :key="item.content_type"
                  class="form-check form-switch form-switch-lg mb-0 flex-shrink-0 d-inline-flex align-items-center gap-2"
                  dir="ltr"
                >
                  <input
                    type="checkbox"
                    class="form-check-input m-0"
                    :id="'contentTypeSwitch-' + item.content_type"
                    v-model="item.status"
                    :true-value="1"
                    :false-value="0"
                    @change="handleStatusChange(item)"
                  />
                  <label
                    class="form-check-label mb-0 text-nowrap"
                    :for="'contentTypeSwitch-' + item.content_type"
                  >
                    {{ item.content_type }}
                  </label>
                </div>

                <p class="text-muted small mb-0 text-nowrap flex-shrink-0 pt-1">Feed changes are applied every 15 minutes</p>
              </div>
            </div>
          </div>
        </div>
      </div>
  </template>

      <!-- Empty Feed Message -->
      <template v-if="!showLoader && isFeedEmpty">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body text-center py-5">
                <i class="mdi mdi-newspaper-variant-outline fs-1 text-muted mb-3"></i>
                <h4 class="text-muted">Feed is empty!</h4>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- Feed Content -->
      <template v-else-if="!showLoader && !isFeedEmpty">
        <div class="row">
          <div class="col-xl-4">
            <div class="card mh-50">
              <div class="card-body">
                <div class="text-center">
                  <div class="d-flex flex-column align-items-center">
                    <!-- Display one image per page -->
                    <div v-if="currentImage" class="image-container" @click="handleClick">
                      <img
                          :src="currentImage.vertical_image"
                          class="mobile-frame"
                          :alt="currentImage.title || 'Image'"
                      />

                      <!-- Show Play Icon if it's a video -->
                      <div v-if="currentImage && (currentImage.content_type === 'video' || currentImage.content_type === 'short')" class="play-icon">
                        ▶
                      </div>
                      <!-- Bottom-Left Overlay -->
                      <div class="image-overlay">
                        <span class="image-type">{{ currentImage.content_type }}</span>
                        <h5 class="image-title">{{ currentImage.title }}</h5>
                        <span class="image-date">{{ currentImage.published }}</span>
                      </div>
                    </div>

                    <!-- Numbered Pagination -->
                    <div class="dataTables_paginate paging_simple_numbers mt-3">
                      <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          align="center"
                          size="sm"
                          keys="false"
                          class="pagination pagination-rounded mb-0"
                          hide-goto-end-buttons
                          hide-ellipsis
                          limit="6"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-8">


            <div class="card h-100">
              <div class="card-body">
                <div   class="col-12 d-flex justify-content-between align-items-center">
                  <select class="form-select custom-width" v-model="selectedLang" id="selectLang">
                    <option value="" disabled selected>Language</option>
                    <option v-for="lang in newsLanguage" :key="lang" :value="lang">{{ lang ? lang.toUpperCase() : '' }}</option>
                  </select>
                  <div class="text-center">
                    <h4 class="mb-0">Feed Item</h4>
                    <span v-if="isPinned" class="badge bg-warning text-dark">PINNED</span>
                  </div>

                  <button
                      @click="handlePinAction"
                      :class="{ 'btn-danger': isPinned, 'btn-success': !isPinned }"
                      class="btn float-end"
                      :disabled="tryingToSubmit || showLoader"
                  >
                    {{ isPinned ? "Unpin" : "Pin" }}
                    <b-spinner v-show="tryingToSubmit" small></b-spinner>
                  </button>
                </div>

                <p v-if="currentImage && currentImage.title"><strong>Title: </strong>{{ decodeHtmlEntities(currentImage.title) }}</p>

                <p v-if="currentImage && currentImage.link"><strong>Link:</strong> <a :href="currentImage.link"  target="_blank">
                  {{ currentImage.link }}
                </a></p>

                <p v-if="currentImage && currentImage.image"><strong>Image:</strong> <a :href="currentImage.image" target="_blank">
                  {{ currentImage.image }}
                </a></p>

                <p v-if="currentImage && currentImage.source_id"><strong>Source ID: </strong>{{ decodeHtmlEntities(currentImage.source_id) }}</p>

                <p v-if="currentImage && currentImage.original_link"><strong>Original Link:</strong> <a :href="currentImage.original_link" target="_blank">
                  {{ currentImage.original_link }}
                </a></p>

                <p v-if="currentImage && currentImage.published"><strong>Published: </strong>{{ currentImage.published }}</p>

                <p v-if="currentImage && currentImage.type"><strong>Type: </strong>{{ currentImage.type }}</p>

                <p v-if="currentImage && currentImage.content_type"><strong>Content Type: </strong>{{ currentImage.content_type }}</p>

                <p v-if="currentImage && currentImage.vertical_image">
                  <strong>Vertical Image: </strong>
                  <img :src="currentImage.vertical_image" alt="Vertical Image" style="max-width: 100px; max-height: 100px;">

                  <a href="javascript:void(0);" class="px-2 text-primary"
                     v-b-tooltip.hover title="Edit"
                     @click="callModalEditVerticalImage(currentImage)">
                    <i class="uil uil-pen font-size-18"></i>
                  </a>
                </p>


                <p v-if="currentImage && currentImage.pin_end_time">
                  <strong>Pin End Time: </strong>{{ currentImage.pin_end_time }}
                </p>



              </div>
            </div>


          </div>
        </div>
      </template>

      <!-- Loading State -->
      <template v-else-if="showLoader">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body d-flex align-items-center justify-content-center py-5">
                <div class="text-center">
                  <b-spinner large></b-spinner>
                  <p class="mt-2 text-muted">Loading feed...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <modalUpdatePinFeed @onRefresh="(itemId) => getNewsFeed(selectedLang, itemId)"  :pinDate="pinDate" ></modalUpdatePinFeed>
    <modalEditVerticalImage @onRefresh="getNewsFeed(selectedLang)"  :verticalImage="verticalImage" ></modalEditVerticalImage>

  </Layout>
</template>

<style scoped>
/* Image container */
.image-container {
  width: 250px;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: black;
  border-radius: 30px;
  padding: 10px;
  overflow: hidden;
  cursor: pointer; /* Makes it clear it's clickable */
}

/* Mobile phone styled image */
.mobile-frame {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
}

/* Play icon styling */
.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 50px;
  color: white;
  background: rgba(0, 0, 0, 0.6);
  padding: 15px 25px;
  border-radius: 50%;
  font-weight: bold;
}

/* Bottom-Left Overlay */
.image-overlay {
  position: absolute;
  bottom: 10px;
  left: 10px;
  color: white;
  padding: 10px;
  text-align: left;
  max-width: 90%;
}

/* Badge Styling for .image-title and .image-type */
.image-type {
  background-color: #007bff; /* Blue background */
  color: white;
  padding: 1px 5px;
  border-radius: 30px;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
  font-size: 12px; /* Adjust size as needed */
  margin-bottom: 10px;
}

/* Slightly smaller date text */
.image-date {
  font-size: 12px; /* Smaller font size */
  color: rgba(255, 255, 255, 0.7); /* Lighter color */
  text-shadow: none;
}
.image-title {
  color: white;
}

/* Play icon adjustments */
.play-icon {
  padding: 10px 20px !important;
  font-size: 30px !important;
}
.content-box {
  background-color: #f9f9f9; /* Light background for readability */
  padding: 20px; /* Add padding around the content */
  border-radius: 8px; /* Rounded corners */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Subtle shadow for a card-like effect */
  font-size: 14px; /* Slightly larger font size for better readability */
  line-height: 1.6; /* Improved line spacing */
  color: #333; /* Dark text color for readability */
  margin-top: 15px; /* Add margin above the content box */
}

/* Optional: Adjust links inside content */
.content-box a {
  color: #007bff; /* Blue color for links */
  text-decoration: none; /* Remove underline */
  font-weight: bold;
}

.content-box a:hover {
  text-decoration: underline; /* Underline links on hover */
}
.custom-width {
  width: 13%;
}
</style>
